<template>
    <div class="d-block d-md-flex align-items-center" v-if="android !== null || ios !== null">
        <i class="fas fa-mobile-alt mb-2"></i>
        <div class="ml-0 ml-md-5">
            <h2>Baixe Nosso Aplicativo</h2>
            <p>Disponível para {{android !== null ? 'Android':''}} {{android !== null && ios !== null ? 'e':''}} {{ios !== null ? 'IOS':''}}</p>
        </div>
        <div class="ml-auto links-download">
            <a v-if="android !== null" :href="android"><img class="m-2" src="@/assets/imgs/img-google-play.png"></a>
            <a v-if="ios !== null" :href="ios"><img class="m-2" src="@/assets/imgs/img-apple-store.png"></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AppStore",
        data:function () {
            return{
                android:null,
                ios:null
            }
        },
        mounted() {
            axios.get('/api/webdriver/landpage',{params:{tags:'download_app_android'}}).then(res => {
                this.android = res.data.data[0].content;
                axios.get('/api/webdriver/landpage',{params:{tags:'download_app_ios'}}).then(res => {
                    this.ios = res.data.data[0].content;
                    if(this.ios !== null || this.android !== null){
                        this.$emit('show',true);
                    }
                })
            });
        }
    }
</script>

<style scoped>

    i{
        color: #ffffff;
        font-size: 100px;
    }

    h2{
        font-size: 34px;
        color: #ffffff;
        font-family: Roboto-Black;
        margin: 0;
    }

    p{
        font-size: 14px;
        color: #ffffff;
        font-family: Roboto-Regular;
        margin: 0;
    }

    .links-download{
        text-align: center;
    }

    @media only screen and (min-width: 1025px){
        .links-download{
            text-align: right;
        }
    }

    @media only screen and (max-width: 768px) {
        *{
            text-align: center !important;
        }

        p{
            margin-top: 20px;
            margin-bottom: 5px;
        }
    }


</style>